import { Color } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const itemBgPath = "/assets/vrUI/hierarchyPanel/itemBg.png";
const visibleIconPath = "/assets/vrUI/hierarchyPanel/visible.png";
const hideIconPath = "/assets/vrUI/hierarchyPanel/hide.png";
const closeIconPath = "/assets/vrUI/common/close.png";

export class HierarchyPanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    const treeData = this.manager.materialManager.getMeshTree();
    //console.log(treeData);

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      map: bgMap,
      opacity: 1,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    container.position.x -= 0.5;
    //container.scale.set(0.5, 0.5, 0.5);

    this.uiElements.push(container);

    // title
    const title = this.uilib.createText({
      text: "对象树",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    const visibleIcon = await this.manager.loadManager.loadTexture(
      visibleIconPath
    );
    const hideIcon = await this.manager.loadManager.loadTexture(hideIconPath);
    const itemBg = await this.manager.loadManager.loadTexture(itemBgPath);

    // tree
    const tree = this.uilib.createTree({
      data: treeData,
      dataTextName: "name",
      dataUniqueName: "nodeId",
      dataChildrenName: "children",
      width: width * 0.9,
      height: height - 0.2,
      radius: 0,
      color: 0x000000,
      opacity: 0,
      textColor: 0xa8b4db, //0xa8b4db,
      textSize: 0.045,
      padding: 0,
      itemHeight: 0.1,
      itemOffset: 0,
      itemBgMap: itemBg,
      font: "bold",
      sliderColor: "#252C3C",
      handleColor: "#8993C3",
      itemSelectColor: 0xa8b4db,
      visibleBtnIcon: [visibleIcon, hideIcon],
      visibleBtnStateChangeColor: {
        normal: 0xffffff,
        hover: 0xafbbe3,
        click: 0x3d4146,
      },
    });
    // 注册光标进入树节点事件
    tree.addOnElementHoverEnterEvent((obj) => {
      if (obj._text) VUtil.setTextColor(obj._text, "#6275B5");
    });
    // 注册光标离开树节点事件
    tree.addOnElementHoverExitEvent((obj) => {
      if (obj._text) VUtil.setTextColor(obj._text, "#ffffff");
    });
    // 注册点击树节点显示隐藏按钮事件
    tree.addOnVisibleBtnClickEvent((info, visible) => {
      //console.log("点击显示隐藏按钮", info, visible);
      this.manager.interface.getNodeVisibleorUnvisible(info.id, visible);
    });
    // 注册点击树节点事件
    tree.addOnElementClickEvent((data) => {
      //console.log("点击了树节点，数据为", data);
      this.manager.interface.clickHierarchy(data.nodeId);
    });
    tree.setElementEnableClick(false); // 设置树节点不可点击，只有在场景模型模式和材质库模式下才能点击结构树
    container.add(tree);
    tree.position.y -= 0.07;
    this.hierarchyTree = tree;

    if (!this._visible) {
      this.hide();
    }
  }
  closePanel() {
    super.closePanel();
  }

  //-------------------------------------------------接口函数，外部使用
  /**
   * 由于增加或删除模型导致更新结构树
   * @param {*} ids 节点的nodeId数组
   * @param {*} order "delete"/"add"
   * @param {*} parentId 父节点id，设置为null表示添加到最外层
   */
  updateHierarchy(ids, order, parentId = null) {
    if (!this.hierarchyTree) return;
    if (order === "delete") {
      this.hierarchyTree.removeContent(ids);
    } else if (order === "add") {
      const data = [];
      for (var i = 0; i < ids.length; i++) {
        const model = this.manager.interface.getModelByNodeId(ids[i]);
        if (model) {
          data.push({
            nodeId: ids[i],
            name: model.name,
            modelId: model.modelId,
            visible: model.visible,
          });
        }
      }
      this.hierarchyTree.addContent(data);
    }
  }

  /**
   * 选中结构树上的一些节点
   * @param {*} ids
   */
  selectSomeNode(ids) {
    if (!this.hierarchyTree) return;
    this.hierarchyTree.jumpToNode(ids);
  }

  /**
   * 设置结构树是否可以点击 只有在场景模型模式和材质库模式下才能点击结构树
   * @param {*} enable
   */
  setHierarchyNodeClickable(enable) {
    if (this.hierarchyTree) this.hierarchyTree.setElementEnableClick(enable);
  }
}
